import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';

import { ActiveShow } from '../../../models/common/active-show';
import { SidebarProfile } from '../../../models/common/sidebar';
import { CoreService } from '../../../core/services/core.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MenuModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  /**
   * Identity chip on the right of the bar. Omitted by default so the globally
   * rendered header is unchanged; pages that own their own header pass one in.
   */
  @Input() profile: SidebarProfile | null = null;

  /**
   * Show a logout control. Off by default — pages inside a portal shell already
   * have one in the sidebar, so only headers that stand alone need it.
   */
  @Input() showLogout = false;

  @Output() logout = new EventEmitter<void>();

  /** The active show, or null outside a show portal. */
  activeShow: ActiveShow | null = null;

  /** Profile dropdown contents. */
  menuItems: MenuItem[] = [];

  /** Drives the caret flip and the chip's pressed state. */
  menuOpen = false;

  /** The org picker passes initials only — nothing to render in the text block. */
  get hasIdentity(): boolean {
    return !!(this.profile?.name || this.profile?.location);
  }

  private sub?: Subscription;

  constructor(
    private readonly coreService: CoreService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.sub = this.coreService.activeShow$.subscribe((show) => {
      this.activeShow = show;
      this.cdr.markForCheck();
    });

    this.menuItems = [
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        styleClass: 'app-header__menu-logout',
        command: () => this.logout.emit()
      }
    ];
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
